/* eslint-disable react/forbid-prop-types */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useSelector } from 'react-redux';
import { hasPermission } from 'src/utils/CommonUtils';

const UsePermission = ({
    scope,
}) => {
    const {
        userScopes,
    } = useSelector((state) => state.AuthReducer, shallowEqual);

    const [
        hasRights,
        setHasRights,
    ] = useState(false);

    useEffect(() => {
        setHasRights(hasPermission({
            scope,
            scopeList: userScopes,
        }));
    }, [
        userScopes,
        scope,
    ]);

    return hasRights;
};

UsePermission.propTypes = {
    scope: PropTypes.string.isRequired,
};

UsePermission.defaultProps = {
};

export default UsePermission;
